import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';

@Injectable({
  providedIn: 'root'
})
export class CtbDiotService {
  dataUrl = Config.URL_BASE;
  constructor(private http: HttpClient) {
  }
  get(gral_emp_id: number, mes: number, anio: number): Observable<any> {
    let url_ = this.dataUrl + '/ctb-diot/get/' + gral_emp_id + '/' + mes + '/' + anio;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  getAddDocByDiotId(ctb_diot_id: number): Observable<any> {
    let url_ = this.dataUrl + '/ctb-diot/get/add_doc_by_diot_id/' + ctb_diot_id;
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  put(dto: any): Observable<any> {
    let url_ = this.dataUrl + '/ctb-diot/put';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.put(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
  post(list: any[]): Observable<any> {
    let url_ = this.dataUrl + '/ctb-diot/descarga/diot';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.post(url_, list, { responseType: 'blob' }).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }
}
